import { withI18n } from '@lingui/react'
import { bool, func, shape, string } from 'prop-types'
import { compose } from 'redux'

import './RxSelectModal.scss'
import Button from 'views/components/atoms/Button'
import IconCircleInfo from 'views/components/atoms/Icon/IconCircleInfo'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import Modal from 'views/components/molecules/Modal'
import RxDifferenceModal from 'views/components/organisms/RxDifferenceModal'
import { RX_DIFFERENCE_MODAL_ID, RX_SELECT_MODAL_ID } from 'views/consts'
import withMountPoints from 'views/enhancers/withMountPoints'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { mountPointsType } from 'views/utils/propTypes'

const RxSelectModal = ({
  i18n,
  mountPoints,
  offerId,
  prescriptionType,
  productId,
  open,
}) => {
  const href = mountPoints.getAddToCart({
    cartAction: 'add',
    eventName: 'addToCart_rx_select_modal',
    eventType: 'conversion',
    offer: offerId,
    prescriptionType,
    product: productId,
    quantity: 1,
  })

  return (
    <>
      <Modal
        data-qa-id="form-rx-selection-modal"
        id={RX_SELECT_MODAL_ID}
        title={i18n._('rxSelectModal.title')}
        open={open}
      >
        <div className="a-box a-box--white">
          <p className="a-h3 u-font-weight--normal u-margin-large--bottom">
            {i18n._('rxSelectModal.description')}
          </p>
          <div className="u-margin-small--top">
            <Button
              data-clientside-hook="conventional-prescription"
              data-qa-id="form-rx-selection-modal-normal-rx-button"
              href={href}
            >
              {i18n._('rxSelectModal.conventionalPrescription')}
            </Button>
          </div>
          <div className="u-margin-small--top">
            <Button
              data-clientside-hook="e-prescription"
              data-qa-id="form-rx-selection-modal-e-rx-button"
              href={mountPoints.getPrescriptionManager()}
            >
              {i18n._('rxSelectModal.ePrescription')}
            </Button>
          </div>
          <div
            className="o-RxSelectModal-info u-hidden u-margin-small--top"
            data-clientside-hook="prescription-info"
          >
            <IconCircleInfo
              className="o-RxSelectModal-infoIcon u-margin-xx-small--top u-margin-xx-small--right"
              size="x-small"
            />
            <p
              className="u-hidden"
              data-clientside-hook="conventional-prescription-info"
            >
              {i18n._('rxSelectModal.conventionalPrescription.info')}
            </p>
            <p className="u-hidden" data-clientside-hook="e-prescription-info">
              {i18n._('rxSelectModal.ePrescription.info')}
            </p>
            <p className="u-hidden" data-clientside-hook="mirakl-info">
              {i18n._('rxSelectModal.mirakl.info')}
            </p>
          </div>
          <p className="u-margin-xx-large--top">
            <ButtonAsLink
              data-a11y-dialog-show={RX_DIFFERENCE_MODAL_ID}
              data-clientside-hook="difference-link"
              data-qa-id="form-rx-selection-modal-info-link"
              href={`#${RX_DIFFERENCE_MODAL_ID}`}
              underlined
            >
              {i18n._('rxSelectModal.differenceLink')}
            </ButtonAsLink>
          </p>
        </div>
      </Modal>
      <RxDifferenceModal />
    </>
  )
}

RxSelectModal.propTypes = {
  i18n: shape({
    _: func.isRequired,
  }).isRequired,
  mountPoints: mountPointsType.isRequired,
  offerId: string.isRequired,
  productId: string.isRequired,
  prescriptionType: string.isRequired,
  open: bool,
}

RxSelectModal.defaultProps = {
  open: false,
}

export default compose(
  withI18n(),
  withShopAndRuntimeConfig,
  withMountPoints
)(RxSelectModal)
